import React, { useState } from "react";
import LoadingGlass from "../loadSpinner/LoadingGlass";
import PaymentFormContainer from "../paymentForm/PaymentFormContainer";
import PremiumSlider from "../paymentForm/PremiumSlider";
import "./Modal.scss";
import { withDefaults } from "../../utils/withDefaults";
import type { PaymentFormProps } from "../paymentForm/PaymentForm";

export interface PremiumModalProps {
  subType?: string;
  children?: React.ReactNode;
  renderButtons?: PaymentFormProps["renderButtons"];
}

export default function PremiumModal(incomingProps: PremiumModalProps) {
  const props = withDefaults(incomingProps, premiumModalDefaultProps);

  const [premiumAmount, setPremiumAmount] = useState(5);
  const [isProcessing, setIsProcessing] = useState(false);

  return (
    <div className="premium-modal">
      {isProcessing ? (
        <LoadingGlass style={{ transform: "translate(-30px, -95px)" }} />
      ) : null}
      {props.children}
      <PremiumSlider
        premiumAmount={premiumAmount}
        setPremiumAmount={setPremiumAmount}
      />
      <PaymentFormContainer
        premiumAmount={premiumAmount}
        setIsProcessing={setIsProcessing}
        renderButtons={props.renderButtons}
      />
    </div>
  );
}

const premiumModalDefaultProps = {
  subType: "Styles"
};
